import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  styled,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";



import Person2Icon from "@mui/icons-material/Person2";
import RedoIcon from "@mui/icons-material/Redo";
import useAuth from "../../../hooks/useAuth";
import { useFetchEmployeeProfileMutation } from "../../../services/profileService";


function Preview() {
  const { users } = useAuth();
 

  const navigate = useNavigate();
  const employeeId = users?.user_id;
 

//   const [anchorProfile, setAnchorProfile] = useState(null);
//   const [anchorNotification, setAnchorNotification] = useState(null);

  const [profileCompletion, setProfileCompletion] = useState(50); // Default completion
  // const [profileData, setProfileData] = useState({});
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const [fetchEmployeeProfile] = useFetchEmployeeProfileMutation();

//   const openProfileMenu = Boolean(anchorProfile);
//   const openNotificationMenu = Boolean(anchorNotification);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetchEmployeeProfile(employeeId).unwrap();
        // setProfileData(response.data);
        calculateCompletion(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (employeeId) {
      fetchProfile();
    }
  }, [employeeId, fetchEmployeeProfile]);

  const calculateCompletion = (data) => {
    let completedFields = 0;
    const totalFields = 2; // Adjust to the number of fields you're checking

    if (data?.job_title) completedFields++;
    
    if (data?.purpose) completedFields++;

    const percentage = Math.round((completedFields / totalFields) * 100);
    setProfileCompletion(percentage);
    setIsProfileCompleted(percentage === 100);
  };

  return (
    <>
      <SectionWrap component="section">
        <ContainerWrap>
          <RowWrap>
            {/* Profile Completion */}
            <Col6Wrap>
              <DashboardBoxWrap>
                {isProfileCompleted ? (
                  <>
                    <Avatar
                      sx={{
                        bgcolor: "#2e7d32",
                        margin: "0 auto 10px",
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <Person2Icon sx={{ fontSize: "40px" }} />
                    </Avatar>
                    <TitleWrap sx={{ color: "#2e7d32" }}>
                      {profileCompletion}%
                    </TitleWrap>
                  </>
                ) : (
                  <>
                    <Avatar
                      sx={{
                        bgcolor: "#d32f2f",
                        margin: "0 auto 10px",
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <Person2Icon sx={{ fontSize: "40px" }} />
                    </Avatar>
                    <TitleWrap sx={{ color: "#d32f2f" }}>
                      {profileCompletion}%
                    </TitleWrap>
                  </>
                )}

                <TitleWrap>Profile Completion</TitleWrap>
                {isProfileCompleted ? (
                  <ContentWrap>
                    Your profile is 100% complete! Great job!
                  </ContentWrap>
                ) : (
                  <ContentWrap>
                    Complete your profile to unlock more features.
                  </ContentWrap>
                )}
                <CustomBtn
                  type="submit"
                  variant="outlined"
                  onClick={() => navigate("/employee/profile/basic-info")}
                >
                  Update Profile
                </CustomBtn>
              </DashboardBoxWrap>
            </Col6Wrap>

            {/* Next Steps */}
            <Col6Wrap>
              <DashboardBoxWrap>
                <Avatar
                  sx={{
                    bgcolor: "#F28021",
                    margin: "0 auto 20px",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <RedoIcon sx={{ fontSize: "40px" }} />
                </Avatar>
                <TitleWrap>RoleReview</TitleWrap>
                <ContentWrap>
                  Complete your profile to 100% by filling in all required
                  details. Once your profile is complete, you will unlock
                  additional features.
                </ContentWrap>
                {isProfileCompleted && (
                  <CustomBtn
                    type="submit"
                    variant="outlined"
                    onClick={() => navigate("/user_details-steps")}
                  >
                    Start RoleReview
                  </CustomBtn>
                )}
              </DashboardBoxWrap>
            </Col6Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
    </>
  );
}

export default Preview;

const SectionWrap = styled(Box)(() => ({
    padding: "50px 0",
  }));
  const ContainerWrap = styled(Box)(() => ({
    width: "100%",
    maxWidth: "1170px",
    paddingLeft: "15px",
    paddingRight: "15px",
    marginLeft: "auto",
    marginRight: "auto",
  }));
  const RowWrap = styled(Box)(() => ({
    display: "flex",
    flexWrap: "wrap",
    marginLeft: "-15px",
    marginRight: "-15px",
  }));
  const Col6Wrap = styled(Box)(() => ({
    flex: "0 0 auto",
    width: "100%",
    maxWidth: "50%",
    paddingLeft: "15px",
    paddingRight: "15px",
    "@media (max-width: 767px)": {
      maxWidth: "100%",
    },
  }));
  const DashboardBoxWrap = styled(Box)(() => ({
    padding: "50px 50px",
    background: "#ffffff",
    borderRadius: "7px",
    textAlign: "center",
    marginBottom: "30px",
    height: "calc(100% - 30px)",
    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
    "@media (max-width: 991px)": {
      padding: "30px 30px",
    },
  }));
  const TitleWrap = styled(Typography)(() => ({
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "1.445",
    color: "#000000",
    marginBottom: "15px",
  }));
  const ContentWrap = styled(Typography)(() => ({
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "1.445",
    color: "#7C7C7C",
    marginBottom: "25px",
  }));
  const CustomBtn = styled(Button)(() => ({
    width: "100%",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "1",
    color: "#ffffff",
    textTransform: "capitalize",
    background: "#F28021",
    borderColor: "#F28021",
    borderRadius: "10px",
    padding: "13px 10px",
    maxWidth: "200px",
    boxShadow: "none !important",
  }));
  // const DialogTitleWrap = styled(DialogTitle)(() => ({
  //   fontSize: "20px",
  //   fontWeight: "600",
  //   lineHeight: "1.445",
  //   color: "#000000",
  //   marginBottom: "15px",
  //   padding: "0",
  // }));